import { default as Project } from './Project';

export default Project;
